module.exports = __webpack_public_path__ + "img/idea_score.8feae9b9.svg";